<template>
  <div class="common-field uk-flex uk-flex-middle uk-width-1-1">
    <div
      class="label-wrapper uk-width-small uk-padding-small uk-padding-remove-vertical uk-padding-remove-left uk-text-right"
    >
      <label :for="id" class="uk-form-label b-text-color--sonic-silver">{{ label }}</label>
    </div>
    <div class="input-wrapper">
      <b-input
        v-model="inputValue"
        :id="id"
        :is-error="isError"
        :type="type"
        :name="name"
        :disabled="isDisabled"
        :class="{'uk-form-danger uk-animation-shake': isError}"
        :autocomplete="autocomplete"
        @input="input"
        @change="change"
      />
      <slot name="password-icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonPagesField',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String
    },
    id: {
      type: String
    },
    type: {
      type: String,
      default: 'Text'
    },
    name: {
      type: String,
      default: ''
    },
    isError: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    input(value) {
      this.$emit('input', value)
    },
    change(value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.common-field {
  &.password-input-block {
    .uk-input {
      padding-right: 60px;
    }
  }

  + .common-field {
    margin-top: 24px;
  }

  .input-wrapper {
    max-width: 420px;
    width: 100%;
    position: relative;

    .password-button {
      position: absolute;
      right: 20px;
      top: 10px;
      background: transparent;
      border: none;
      cursor: pointer;
    }
  }

  .label-wrapper {
    width: 150px;
    min-width: 150px;
  }

  input {
    font-size: 1.5rem;
    color: #323232;
  }
}
</style>
